export const distortionsContractAddress =
  "0x0A337Be2EA71E3aeA9C82D45b036aC6a6123B6D0";
export const tokenContractAddress =
  "0xa346D51362E2cF7c09cf38Ccf5E2b208B071e71b";
export const stakingContractAddress =
  "0x51697170F78136c8d143B0013Cf5B229aDe70757";